import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/re`;
const headers = () => {
  const t = localStorage.getItem("nex_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const pillarApi = {
  get: (path, params) => axios.get(`${BASE}${path}`, { headers: headers(), params }).then((r) => r.data),
  post: (path, body) => axios.post(`${BASE}${path}`, body, { headers: headers() }).then((r) => r.data),
  patch: (path, body) => axios.patch(`${BASE}${path}`, body, { headers: headers() }).then((r) => r.data),
  del: (path) => axios.delete(`${BASE}${path}`, { headers: headers() }).then((r) => r.data),
};

export const pillarErr = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || x).join(", ");
  if (d && typeof d === "object") return d.message || JSON.stringify(d);
  return d || e?.message || "Request failed";
};

export const pillarDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString([], { dateStyle: "medium", timeStyle: "short" });
};

export const label = (s) => (s ? String(s).replace(/_/g, " ") : "—");
export const pillarDot = (hex) => (hex === "#0A0612" ? "#9b8cff" : hex);
